/* eslint-disable react/jsx-indent */
import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { ConfirmationNumber, ReceiptOutlined } from '@material-ui/icons';
import SmsOutlinedIcon from '@material-ui/icons/SmsOutlined';
import { modules, permissions } from '../../common/permissions';

const SvgStyle = {
  marginRight: '8%',
  verticalAlign: 'bottom',
  fontSize: '20px',
  '@media only screen and(maxWidth: 1420px)': {
    fontSize: 20,
  },
};

const messageSvgStyle = {
  marginRight: '8%',
  verticalAlign: 'middle',
  fontSize: '26px',
  '@media only screen and(maxWidth: 1420px)': {
    fontSize: 26,
  },
}

const LinkSvgStyle = {
  marginRight: '10%',
  verticalAlign: 'bottom',
  fontSize: '20px',
  '@media only screen and(maxWidth: 1420px)': {
    fontSize: 20,
  },
};
const EmailStyle = {
  marginRight: '8%',
  verticalAlign: 'bottom',
  fontSize: '26px',
  color: 'white',
  '@media only screen and(maxWidth: 1420px)': {
    fontSize: 26,
  },
};
const SvgVisitorStyle = {
  marginRight: '9%',
  verticalAlign: 'bottom',
  fontSize: '20px',
  '@media only screen and(maxWidth: 1420px)': {
    fontSize: 20,
  },
};

const SvgLeadStyle = {
  marginRight: '9%',
  verticalAlign: 'bottom',
  width: '20px',
  '@media only screen and(maxWidth: 1420px)': {
    width: '20px',
  },
};

const OrderStyle = {
  marginRight: '8%',
  verticalAlign: 'bottom',
  fontSize: '20px',
  color: '#ffffff',
  marginTop: 0,
  width: 20,
  height: 20,
};

const structure = [
  {
    id: 1,
    menuid: 1,
    label: 'Home',
    link: '/app/home/business',
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_101.svg" alt="Sidebar" />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_2.svg" alt="Sidebar" />,
    children: [
      {
        label: (
          <>
            <div>
              <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_65.svg" alt="Sidebar" style={SvgStyle} />
              <span>Plans</span>
            </div>
          </>
        ),
        link: '/app/plans',
        moduleid: 7,
        roles: [1, 2, 3, 4, 5],
        sideMenu: 'home',
        sideModule: modules.plan,
        sidePermission: permissions.managePlan,
      },
      {
        link: '/app/setting',
        moduleid: 8,
        label: (<>
          <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_66.svg" alt="Sidebar" style={SvgStyle} />
          Settings
        </>),
      },
    ],
  },
  {
    id: 2,
    menuid: 3,
    moduleid: 19,
    label: (
      <>
        Contacts
      </>
    ),
    link: '/app/contact-central',
    sideMenu: 'crm',
    sideModule: modules.contacts,
    sidePermission: permissions.contactGrid,
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_618.svg" alt="Sidebar" />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_618.svg" alt="Sidebar" />,
  },
  {
    id: 3,
    menuid: 3,
    moduleid: 12,
    label: (
      <>
        Lead Finder
      </>
    ),
    link: '/app/lead-find',
    sideMenu: 'crm',
    sideModule: modules.emailFinder,
    sidePermission: permissions.manageEmailFinder,
    icon: <svg style={SvgLeadStyle} xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fillRule="evenodd" clip-rule="evenodd" viewBox="0 0 445 512.53">
      <path fill="white" fillRule="nonzero" d="M86.49 87.84c-3.16-5.05-9.12-11.91-9.12-17.83 0-3.34 2.64-7.7 6.42-8.66-.3-5.01-.5-10.08-.5-15.11 0-2.98.05-5.99.17-8.94.16-1.85.5-3.7 1-5.5a31.795 31.795 0 0 1 14.19-18.03c2.41-1.51 5.02-2.7 7.69-3.67 4.88-1.78 2.52-9.99 7.87-10.09 12.47-.33 33.01 11.1 41.01 19.77a31.68 31.68 0 0 1 8.18 20.53l-.5 21.87c2.21.54 4.69 2.27 5.24 4.5 1.72 6.89-5.45 15.48-8.77 20.97-3.08 5.08-14.81 21.46-14.82 21.57-.05.59.25 1.36 1.05 2.56 16.69 22.93 58.52 11.63 66.19 47.82H33.7c7.67-36.23 49.52-24.89 66.2-47.82.9-1.32 1.31-2.03 1.29-2.61 0-.32-13.49-19.41-14.7-21.33zM374.8 223.75l-60.11 70.45-16.23-13.92 60.11-70.44 16.23 13.91zm-73.71 86.39-21.24 24.91-16.24-13.91 21.25-24.92 16.23 13.92zm-9.39 202.39H143.38V377.48L11.57 221.09c-5.2-6.47-8.8-13.18-10.45-19.39-1.55-5.84-1.53-11.54.29-16.6 2.01-5.6 6.02-10.1 12.1-12.95 4.17-1.95 9.35-3.05 15.52-3.08l381.82-.05c6.89-.25 12.99.83 18.02 2.99 6.1 2.58 10.67 6.83 13.42 12.31 2.65 5.3 3.42 11.53 2.03 18.3-1.3 6.3-4.49 13.14-9.84 20.13l-132.05 154.8v134.98H291.7zm-126.88-21.45h116.16V373.65l2.61-6.96 133.99-157.05c3.28-4.32 5.16-8.15 5.82-11.32.4-1.92.3-3.44-.21-4.46-.42-.84-1.37-1.62-2.76-2.21-2.21-.99-5.27-1.42-9.08-1.24l-382.28.05c-2.9-.04-5.08.36-6.53 1.03-.59.28-.94.57-1.02.8-.28.79-.18 2.15.29 3.88.91 3.44 3.13 7.44 6.41 11.54l134.05 159.07 2.55 6.87v117.43zM286 87.84c-3.18-5.05-9.13-11.91-9.13-17.83 0-3.34 2.63-7.7 6.41-8.66-.3-5.01-.5-10.08-.5-15.11 0-2.98.06-5.99.17-8.94.16-1.85.51-3.7 1.01-5.5a31.738 31.738 0 0 1 14.18-18.03c2.41-1.51 5.09-2.74 7.7-3.67 4.83-1.71 2.51-9.99 7.86-10.09 12.48-.33 33.02 11.1 41.03 19.77a31.764 31.764 0 0 1 8.16 20.53l-.5 21.87c2.22.54 4.73 2.34 5.25 4.5 1.64 6.85-5.46 15.48-8.78 20.97-3.07 5.08-14.82 21.52-14.82 21.57 0 .58.25 1.36 1.06 2.56 16.69 22.93 58.51 11.63 66.18 47.82H233.2c7.66-36.23 49.52-24.89 66.2-47.82.89-1.32 1.29-2.03 1.29-2.61 0-.31-13.49-19.41-14.69-21.33z" />
    </svg>,
    iconFill: <svg xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fillRule="evenodd" clip-rule="evenodd" viewBox="0 0 445 512.53">
      <path fill="#ffffff" fillRule="nonzero" d="M86.49 87.84c-3.16-5.05-9.12-11.91-9.12-17.83 0-3.34 2.64-7.7 6.42-8.66-.3-5.01-.5-10.08-.5-15.11 0-2.98.05-5.99.17-8.94.16-1.85.5-3.7 1-5.5a31.795 31.795 0 0 1 14.19-18.03c2.41-1.51 5.02-2.7 7.69-3.67 4.88-1.78 2.52-9.99 7.87-10.09 12.47-.33 33.01 11.1 41.01 19.77a31.68 31.68 0 0 1 8.18 20.53l-.5 21.87c2.21.54 4.69 2.27 5.24 4.5 1.72 6.89-5.45 15.48-8.77 20.97-3.08 5.08-14.81 21.46-14.82 21.57-.05.59.25 1.36 1.05 2.56 16.69 22.93 58.52 11.63 66.19 47.82H33.7c7.67-36.23 49.52-24.89 66.2-47.82.9-1.32 1.31-2.03 1.29-2.61 0-.32-13.49-19.41-14.7-21.33zM374.8 223.75l-60.11 70.45-16.23-13.92 60.11-70.44 16.23 13.91zm-73.71 86.39-21.24 24.91-16.24-13.91 21.25-24.92 16.23 13.92zm-9.39 202.39H143.38V377.48L11.57 221.09c-5.2-6.47-8.8-13.18-10.45-19.39-1.55-5.84-1.53-11.54.29-16.6 2.01-5.6 6.02-10.1 12.1-12.95 4.17-1.95 9.35-3.05 15.52-3.08l381.82-.05c6.89-.25 12.99.83 18.02 2.99 6.1 2.58 10.67 6.83 13.42 12.31 2.65 5.3 3.42 11.53 2.03 18.3-1.3 6.3-4.49 13.14-9.84 20.13l-132.05 154.8v134.98H291.7zm-126.88-21.45h116.16V373.65l2.61-6.96 133.99-157.05c3.28-4.32 5.16-8.15 5.82-11.32.4-1.92.3-3.44-.21-4.46-.42-.84-1.37-1.62-2.76-2.21-2.21-.99-5.27-1.42-9.08-1.24l-382.28.05c-2.9-.04-5.08.36-6.53 1.03-.59.28-.94.57-1.02.8-.28.79-.18 2.15.29 3.88.91 3.44 3.13 7.44 6.41 11.54l134.05 159.07 2.55 6.87v117.43zM286 87.84c-3.18-5.05-9.13-11.91-9.13-17.83 0-3.34 2.63-7.7 6.41-8.66-.3-5.01-.5-10.08-.5-15.11 0-2.98.06-5.99.17-8.94.16-1.85.51-3.7 1.01-5.5a31.738 31.738 0 0 1 14.18-18.03c2.41-1.51 5.09-2.74 7.7-3.67 4.83-1.71 2.51-9.99 7.86-10.09 12.48-.33 33.02 11.1 41.03 19.77a31.764 31.764 0 0 1 8.16 20.53l-.5 21.87c2.22.54 4.73 2.34 5.25 4.5 1.64 6.85-5.46 15.48-8.78 20.97-3.07 5.08-14.82 21.52-14.82 21.57 0 .58.25 1.36 1.06 2.56 16.69 22.93 58.51 11.63 66.18 47.82H233.2c7.66-36.23 49.52-24.89 66.2-47.82.89-1.32 1.29-2.03 1.29-2.61 0-.31-13.49-19.41-14.69-21.33z" />
    </svg>,
  },
  {
    id: 4,
    menuid: 3,
    moduleid: 21,
    label: (
      <>
        Email Finder
      </>
    ),
    link: '/app/email-find',
    sideMenu: 'crm',
    sideModule: modules.emailFinder,
    sidePermission: permissions.manageEmailFinder,
    icon: <SearchIcon style={EmailStyle} />,
    iconFill: <SearchIcon style={EmailStyle} />,
  },
  {
    id: 5,
    menuid: 2,
    moduleid: 13,
    label: (
      <>
        Appointments
      </>
    ),
    link: '/app/lead-central/appointment',
    sideMenu: 'leads',
    sideModule: modules.appointments,
    sidePermission: permissions.manageAppointment,
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_611.svg" alt="Sidebar" style={SvgStyle} />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_611.svg" alt="Sidebar" style={SvgStyle} />,
  },
  {
    id: 6,
    menuid: 2,
    moduleid: 11,
    label: (
      <>
        Workflows
        <span
          style={{
            marginLeft: 7,
            position: 'relative',
            top: '-8px', // move it upward
            background: 'red',
            padding: '2px 6px 4px 4px',
            borderRadius: 9,
            fontSize: 8,
          }}
        >New</span>
      </>
    ),
    link: '/app/lead-central/workflow-automation',
    sideMenu: 'leads',
    sideModule: modules.workflows,
    sidePermission: permissions.workflowList,
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_610.svg" alt="Sidebar" />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_610.svg" alt="Sidebar" />,
  },
  {
    id: 7,
    menuid: 10,
    label: 'LinkedIn',
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/outline%20linkedin.svg" alt="Sidebar" width="20px" height="20px" />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/filled%20linkedin.svg" width="20px" height="20px" alt="Sidebar" />,
    link: '/app/linkedin/data-collection',
    children: [
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/outline%20linkedin.svg" width="24px" height="24px" alt="Sidebar" style={SvgStyle} />
            Connect LinkedIn
          </>
        ),
        moduleid: 70,
        link: '/app/linkedin/connect-account?frsi=true',
        sideMenu: 'linkedIn',
        sideModule: modules.advanceLinkedInSequence,
        sidePermission: permissions.manageAdvanceLinkedinSequence,
      },
      {
        label: (
          <>
            <SearchIcon style={LinkSvgStyle} />
            LinkedIn Finder
          </>
        ),
        moduleid: 71,
        link: '/app/linkedin/finder',
        sideMenu: 'linkedIn',
        sideModule: modules.advanceLinkedInSequence,
        sidePermission: permissions.manageAdvanceLinkedinSequence,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/data%20collect.svg" alt="Sidebar" width="25px" height="25px" style={SvgStyle} />
            Data Collection
          </>
        ),
        moduleid: 51,
        link: '/app/linkedin/data-collection',
        sideMenu: 'linkedIn',
        sideModule: modules.dataCollection,
        sidePermission: permissions.manageDataCollection,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/linkedinsequence.svg" alt="Sidebar" style={SvgStyle} />
            LinkedIn Automation (Extn)
          </>
        ),
        moduleid: 52,
        link: '/app/lead-central/linkedin-automation',
        sideMenu: 'linkedIn',
        sideModule: modules.linkedInSequence,
        sidePermission: permissions.manageLinkedInSequence,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/linkedin%20squance.svg" width="24px" height="24px" alt="Sidebar" style={SvgStyle} />
            LinkedIn Sequences
            <span
              style={{
                marginLeft: 7,
                verticalAlign: 'top',
                background: 'red',
                padding: '2px 6px 4px 4px',
                borderRadius: 9,
                fontSize: 8
              }}
            >New</span>
          </>
        ),
        moduleid: 52,
        link: '/app/linkedin/sequence',
        sideMenu: 'linkedIn',
        sideModule: modules.advanceLinkedInSequence,
        sidePermission: permissions.manageAdvanceLinkedinSequence,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/linkedin-invitations.svg" width="24px" height="24px" alt="Sidebar" style={SvgStyle} />
            Manage Invitations & Posts
          </>
        ),
        moduleid: 57,
        link: '/app/linkedin/manage-invitations',
        sideMenu: 'linkedIn',
        sideModule: modules.advanceLinkedInSequence,
        sidePermission: permissions.manageAdvanceLinkedinSequence,
      },
      {
        label: (
          <>
            <SmsOutlinedIcon style={messageSvgStyle} />
            Messaging
          </>
        ),
        moduleid: 58,
        link: '/app/linkedin/conversations',
        sideMenu: 'linkedIn',
        sideModule: modules.advanceLinkedInSequence,
        sidePermission: permissions.manageAdvanceLinkedinSequence,
      },
    ],
  },
  {
    id: 8,
    menuid: 11,
    label: 'WhatsApp',
    link: '/app/whatsapp/marketing',
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/WhatsApp%20icon.svg" alt="Sidebar" width="20px" height="20px" />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/WhatsApp%20icon%20fill.svg" width="20px" height="20px" alt="Sidebar" />,
    children: [
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/linkedin%20squance.svg" width="24px" height="24px" alt="Sidebar" style={SvgStyle} />
            WhatsApp Sequences
          </>
        ),
        moduleid: 55,
        link: '/app/whatsapp/sequence',
        sideMenu: 'whastApp',
        sideModule: modules.whatsAppSequence,
        sidePermission: permissions.manageWhatsAppSequence,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/WhatsApp%20campaign.svg" width="24px" height="24px" alt="Sidebar" style={SvgStyle} />
            WhatsApp Marketing
          </>
        ),
        moduleid: 54,
        link: '/app/whatsapp/marketing',
        sideMenu: 'whastApp',
        sideModule: modules.whatsAppMarketing,
        sidePermission: permissions.manageWhatsAppMarketing,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/WhatsApp%20conversation.svg" width="24px" height="24px" alt="Sidebar" style={SvgStyle} />
            Conversations
          </>
        ),
        moduleid: 56,
        link: '/app/whatsapp/conversations',
        sideMenu: 'whastApp',
        sideModule: modules.whatsAppConversations,
        sidePermission: permissions.manageWhatsAppConversations,
      },
    ],
  },
  {
    id: 9,
    menuid: 2,
    label: 'Leads',
    link: '/app/lead-central/workflow-automation',
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_7.svg" alt="Sidebar" />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_8.svg" alt="Sidebar" />,
    children: [
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_69.svg" alt="Sidebar" style={SvgStyle} />
            Import Leads
          </>
        ),
        moduleid: 10,
        link: '/app/lead-central/import-lead',
        sideMenu: 'leads',
        sideModule: modules.importLeads,
        sidePermission: permissions.manageImportLeads,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_612.svg" alt="Sidebar" style={SvgStyle} />
            LeadGen Forms
          </>
        ),
        moduleid: 14,
        link: '/app/lead-central/forms',
        sideMenu: 'leads',
        sideModule: modules.leadGenForms,
        sidePermission: permissions.manageLeadGenForms,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_614.svg" alt="Sidebar" style={SvgStyle} />
            Inquiry Forms
          </>
        ),
        moduleid: 15,
        link: '/app/lead-central/inquiry-forms',
        sideMenu: 'leads',
        sideModule: modules.inquiryForms,
        sidePermission: permissions.manageInquiryForms,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/visitor-dashboard.png" width='22px' alt="Sidebar" style={SvgVisitorStyle} />
            Visitor Dashboard
          </>
        ),
        moduleid: 16,
        link: '/app/lead-central/visitors',
        sideMenu: 'leads',
        sideModule: modules.visitorDashboard,
        sidePermission: permissions.manageVisitorDashboard,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_615.svg" alt="Sidebar" style={SvgStyle} />
            Events
          </>
        ),
        moduleid: 17,
        link: '/app/lead-central/event',
        sideMenu: 'leads',
        sideModule: modules.events,
        sidePermission: permissions.manageEvents,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_613.svg" alt="Sidebar" style={SvgStyle} />
            Live Chat
          </>
        ),
        moduleid: 18,
        link: '/app/lead-central/live-chat',
        sideMenu: 'leads',
        sideModule: modules.liveChat,
        sidePermission: permissions.manageLiveChat,
      },
    ],
  },
  {
    id: 10,
    menuid: 4,
    label: 'Marketing',
    link: '/app/lead-central/email-marketing',
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_222.svg" alt="Sidebar" />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_223.svg" alt="Sidebar" />,
    children: [
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/template%20catalog.svg" alt="Sidebar" style={SvgStyle} />
            Catalog
          </>
        ),
        moduleid: 50,
        link: '/app/marketing-central/template-catalog',
        sideMenu: 'marketing',
        sideModule: modules.catalog,
        sidePermission: permissions.catalogList,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_624.svg" alt="Sidebar" style={SvgStyle} />
            News Letter
          </>
        ),
        moduleid: 28,
        link: '/app/marketing-central/news-letter',
        sideMenu: 'marketing',
        sideModule: modules.newsLetter,
        sidePermission: permissions.newsLetterList,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_625.svg" alt="Sidebar" style={SvgStyle} />
            Social Media
          </>
        ),
        moduleid: 29,
        link: '/app/marketing-central/social-media-list',
        sideMenu: 'marketing',
        sideModule: modules.socialMedia,
        sidePermission: permissions.socialMediaList,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_626.svg" alt="Sidebar" style={SvgStyle} />
            Email Marketing
          </>
        ),
        moduleid: 30,
        link: '/app/lead-central/email-marketing',
        sideMenu: 'marketing',
        sideModule: modules.emailMarketing,
        sidePermission: permissions.emailMarketingList,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_628.svg" alt="Sidebar" style={SvgStyle} />
            Text Marketing
          </>
        ),
        moduleid: 31,
        link: '/app/lead-central/text-marketing',
        sideMenu: 'marketing',
        sideModule: modules.textMarketing,
        sidePermission: permissions.textMarketingList,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_629.svg" alt="Sidebar" style={SvgStyle} />
            Pages
          </>
        ),
        moduleid: 32,
        link: '/app/lead-central/content-marketing',
        sideMenu: 'marketing',
        sideModule: modules.pages,
        sidePermission: permissions.PagesList,
      },
    ],
  },
  {
    id: 11,
    menuid: 3,
    label: 'CRM',
    link: '/app/contact-central',
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_16.svg" alt="Sidebar" />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_17.svg" alt="Sidebar" />,
    children: [
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_619.svg" alt="Sidebar" style={SvgStyle} />
            Accounts
          </>
        ),
        moduleid: 20,
        link: '/app/organizations',
        sideMenu: 'crm',
        sideModule: modules.accounts,
        sidePermission: permissions.accountsList,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_620.svg" alt="Sidebar" style={SvgStyle} />
            Documents
          </>
        ),
        moduleid: 22,
        link: '/app/documents',
        sideMenu: 'crm',
        sideModule: modules.documents,
        sidePermission: permissions.documentsList,
      },
      {
        label: (<>
          <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_36.svg" alt="Sidebar" style={SvgStyle} />
          Deals
        </>),
        moduleid: 23,
        link: '/app/deal-central',
        sideMenu: 'crm',
        sideModule: modules.deals,
        sidePermission: permissions.dealsList,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_34.svg" alt="Sidebar" style={SvgStyle} />
            Tasks
          </>
        ),
        moduleid: 24,
        link: '/app/task',
        sideMenu: 'crm',
        sideModule: modules.tasks,
        sidePermission: permissions.tasksList,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_621.svg" alt="Sidebar" style={SvgStyle} />
            Inbox
          </>
        ),
        moduleid: 25,
        link: '/app/home/Inbox',
        menuid: 3,
        roles: [1, 2, 3, 4, 5],
        sideMenu: 'crm',
        sideModule: modules.inbox,
        sidePermission: permissions.inboxList,
      },
      {
        label: (
          <>
            <ConfirmationNumber style={OrderStyle} />
            Service Desk
          </>
        ),
        moduleid: 26,
        link: '/app/tickets',
        sideMenu: 'crm',
        sideModule: modules.serviceDesk,
        sidePermission: permissions.serviceDeskList,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_35.svg" alt="Sidebar" style={SvgStyle} />
            Calls
          </>
        ),
        moduleid: 27,
        link: '/app/call',
        sideMenu: 'crm',
        sideModule: modules.calls,
        sidePermission: permissions.CallsList,
      },
    ],
  },
  {
    id: 12,
    menuid: 5,
    label: 'Sales',
    link: '/app/deal-central',
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_31.svg" alt="Sidebar" />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_32.svg" alt="Sidebar" />,
    children: [
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_637.svg.svg" alt="Sidebar" style={SvgStyle} />
            Product & Service
          </>
        ),
        moduleid: 34,
        link: '/app/product-service',
        sideMenu: 'sales',
        sideModule: modules.productService,
        sidePermission: permissions.productServiceList,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_638.svg.svg" alt="Sidebar" style={SvgStyle} />
            Payment & Invoice
          </>
        ),
        moduleid: 35,
        link: '/app/paymentinvoice',
        sideMenu: 'sales',
        sideModule: modules.paymentInvoice,
        sidePermission: permissions.paymentInvoiceList,
      },
      {
        label: (
          <>
            <ReceiptOutlined style={OrderStyle} />
            Sales Orders
          </>
        ),
        moduleid: 36,
        link: '/app/sales-order',
        sideMenu: 'sales',
        sideModule: modules.salesOrders,
        sidePermission: permissions.salesOrdersList,
      },
    ],
  },
  {
    id: 13,
    menuid: 7,
    label: 'Insights',
    link: '/app/insights-central',
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_448.svg" alt="Sidebar" />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_449.svg" alt="Sidebar" />,
    children: [
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_651.svg" alt="Sidebar" style={SvgStyle} />
            Marketing Dashboard
          </>
        ),
        moduleid: 42,
        link: '/app/insights-central/marketing-dashboard',
        sideMenu: 'insights',
        sideModule: modules.marketingDashboard,
        sidePermission: permissions.manageMarketingDashboard,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_650.svg" alt="Sidebar" style={SvgStyle} />
            Contact Dashboard
          </>
        ),
        moduleid: 43,
        link: '/app/insights-central/contact-dashboard',
        sideMenu: 'insights',
        sideModule: modules.contactDashboard,
        sidePermission: permissions.manageContactDashboard,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_652.svg" alt="Sidebar" style={SvgStyle} />
            Email Report
          </>
        ),
        moduleid: 44,
        link: '/app/insights-central/email-report',
        sideMenu: 'insights',
        sideModule: modules.emailReport,
        sidePermission: permissions.manageEmailReport,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_653.svg" alt="Sidebar" style={SvgStyle} />
            Sales Dashboard
          </>
        ),
        moduleid: 45,
        link: '/app/insights-central/sales-dashboard',
        sideMenu: 'insights',
        sideModule: modules.salesDashboard,
        sidePermission: permissions.manageSalesDashboard,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/sidebar_655.svg" alt="Sidebar" style={SvgStyle} />
            Payment Dashboard
          </>
        ),
        moduleid: 46,
        link: '/app/insights-central/payment-dashboard',
        sideMenu: 'insights',
        sideModule: modules.paymentDashboard,
        sidePermission: permissions.managePaymentDashboard,
      },
    ],
  },
  {
    id: 14,
    menuid: 9,
    label: 'Property Management',
    link: '/app/property',
    icon: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/propertyManagement.png" alt="Sidebar" width="20px" height="20px" />,
    iconFill: <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/PropertyManagementFill.png" width="20px" height="20px" alt="Sidebar" />,
    children: [
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/Property.png" alt="Sidebar" width="20px" height="20px" style={SvgStyle} />
            Property
          </>
        ),
        moduleid: 48,
        link: '/app/property',
        sideMenu: 'propertyManagement',
        sideModule: modules.property,
        sidePermission: permissions.manageProperty,
      },
      {
        label: (
          <>
            <img src="https://storage.googleapis.com/bixpand-staging/WebsiteImages/propertyTransaction.png" alt="Sidebar" width="20px" height="20px" style={SvgStyle} />
            Transaction
          </>
        ),
        moduleid: 49,
        link: '/app/property-transaction',
        sideMenu: 'propertyManagement',
        sideModule: modules.transaction,
        sidePermission: permissions.managePropertyTransactions,
      },
    ],
  },
];

export default structure;
